import { useMutation, useQuery } from "@tanstack/react-query";
import {
  fetchIpInfo,
  verifyReferralCode,
  getSiteSettings,
} from "../api/authApi";

export const useIpInfoQuery = (enabled = true) => {
  return useQuery({
    queryKey: ["ipInfo"],
    queryFn: fetchIpInfo,
    enabled,
    staleTime: Infinity, // IP info doesn't change during a session
    refetchOnWindowFocus: false,
  });
};



export const useVerifyReferralMutation = () => {
  return useMutation({
    mutationFn: verifyReferralCode,
  });
};

export const useSiteSettingsQuery = () => {
  return useQuery({
    queryKey: ["siteSettings"],
    queryFn: getSiteSettings,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnWindowFocus: false,
  });
};
